import DialogWrapper2 from '../../../core/dialog/dialog_wrapper_v2';
import * as React from 'react';
import { ReportText } from './ReportText';
import { WActionButton } from '../../../core/elements/WActionButton';

interface ReportTextButtonProps extends React.ClassAttributes<any> {
    data: any;
    keyData: string;
    standort: number;
    styleProps?: React.CSSProperties;
}

interface ReportTextButtonState {
   showDialog: boolean;
}

export class ReportTextButton extends React.Component<ReportTextButtonProps, ReportTextButtonState> {

    constructor(props: any) {
        super(props);
        this.state = {
           showDialog: false
        };
    }

    render(): JSX.Element {
        return <>
            <WActionButton
                label='Report: Textbaustein konfigurieren'
                insideText='Report: Textbaustein konfigurieren'
                key='config'
                action='showDoc'
                disabled={this.state.showDialog}
                styleProps={{ padding: '1px 8px 1px 2px', whiteSpace: 'nowrap', ...(this.props.styleProps && this.props.styleProps) }}
                onAction={() => this.setState({ showDialog: true })}
            />
            {this.state.showDialog && this.renderDialog()}
        </>;
    }
    
    renderDialog(): JSX.Element {
        return (
            <DialogWrapper2 onAfterClose={() => this.setState({ showDialog: false })}>
                <ReportText
                    data={this.props.data}
                    standort={this.props.standort}
                    keyData={this.props.keyData}
                    onClose={() => this.setState({ showDialog: false })}
                />
            </DialogWrapper2>
        );
    }
}
